import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    DraftState,
    DRAFT_FEATURE_KEY
} from './draft.reducer';

export const getDraftState = createFeatureSelector<
    DraftState
>(DRAFT_FEATURE_KEY);

export const getState = createSelector(
    getDraftState,
    (state: DraftState) => state
);

export const getValidationSchema = createSelector(
    getDraftState,
    (state: DraftState) => {
        return state.validationSchema;
    }
);

export const getValidationResults = createSelector(
    getDraftState,
    (state: DraftState) => {
        return state.validationResults;
    }
);

export const validateListingResponse = createSelector(
    getDraftState,
    (state: DraftState) => {
        return state.validateListingResponse;
    }
);

export const getDraftLoaded = createSelector(
    getDraftState,
    (state: DraftState) => state.draftLoaded
);

export const getDraftData = createSelector(
    getDraftState,
    (state: DraftState) => state.draftData
);

export const getListingActionResponse = createSelector(
  getDraftState,
  (state: DraftState) => state.makeListingActionResponse
);

export const getListingActionLoading = createSelector(
  getDraftState,
  (state: DraftState) => state.makeListingActionLoading
);
